import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { IDashboardGroup } from '@/pages/Dashboards/dashboards.types.ts'
import useDashboardGroup from '@/pages/Dashboards/hooks/useDashboardGroup.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'
import DashboardGroupDropdown from '@/pages/Dashboards/components/DashboardGroupDropdown'

interface IProps {
  groupId: IDashboardGroup['id']
  open: boolean
  onClose: () => void
}

const UpdateDashboardGroupModal = (props: IProps) => {
  const group = useDashboardGroup(props.groupId)
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft, handleChange] = useStateWithChange<IDashboardGroup>(group)

  useEffect(() => {
    setDraft(group)
  }, [group])

  const handleSave = () => {
    wait(dashboardsApi.updateGroup(draft), (resp) => {
      if (resp.status === 'success') {
        dashboardsEvents.groupUpdated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Редактирование группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <DashboardGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={draft.parentId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={draft.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default (props: IProps) => {
  if (!props.groupId) return null

  return <UpdateDashboardGroupModal {...props} />
}
